import "./App.css";

import React, { useState, useEffect } from "react";
import ProtectedRoute from "./Auth/ProtectedRoutes";
import { useLoading } from "./context/loadingContext";
import Navbar from "./components/Navbar/Navbar";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Home from "./components/Home/Home";
import "katex/dist/katex.min.css";
import Resources from "./components/Resources/Resources";
import Profile from "./components/Profile/Profile";
import Footer from "./components/Footer/Footer";
import Archive from "./components/Archive/Archive";
import WeeklyProblems from "./components/Challenges/WeeklyProblems/WeeklyProblems";
import LoginPage from "./components/Login/LoginPage";
import OpenProblems from "./components/Challenges/OpenProblems/OpenProblems";
import Games from "./components/Challenges/Games/Games";
import StudentsSubmission from "./components/Challenges/StudentsSubmissions/StudentsSubmission";
import DailyProblem from "./components/Challenges/DailyProblem/DailyProblem";
import MySubmissions from "./components/Challenges/MySubmissions/MySubmissions";
import Annoucement from "./components/Annoucement/Annoucement";
import UnitLayout from "./components/Challenges/OpenProblems/UnitLayout/UnitLayout";
import LoadingPage from "./Error/LoadingPage/LoadingPage";
import Error403Layout from "./Error/Unauthorized/Error.403Layout";
import Submission4Student from "./components/Submissions/Submission4Student/Submission4Student";
import Submission4Correctors from "./components/Submissions/Submission4Correctors/Submission4Correctors";
import Dashboard from "./components/Dashboard/Dashboard";
import ReportForm from "./components/Report/Reports";
import OutOfServiceProtect from "./Auth/OutOfService";
import OutOfService from "./Error/OutOfService/OutOfService";
import Tubro from "./components/Challenges/Games/Games/Turbo/Tubro";
import ChessBoards from "./components/Challenges/Games/Games/ChessBoards/ChessBoards";
import TermsAndConditions from "./components/Terms&Conditions/Terms&Conditions";
import GuestRoute from "./Auth/GuestRoute";
import Error404Layout from "./Error/Error404/Error404Layout";
import OrderingCards from "./components/Challenges/Games/Games/OrderingCards/OrderingCards";
import Confucius from "./components/Challenges/Games/Games/ConfuciusIMO67/Confucius";

function App() {
  const quotes = [
    {
      quote: "Check our Instagram page @mathtounsi.",

      color: "#FF6B6B", // Soft red
    },
    {
      quote: "Starting is the first step in the Journey of success.",

      color: "#4ECDC4", // Teal
    },
    {
      quote: "Think you hate math? You just haven’t met it properly.",

      color: "#FFD166", // Yellow
    },
    {
      quote:
        "Did you know that a circle has an infinite number of sides? (👀) Math doesn’t lie.",

      color: "#06D6A0", // Mint green
    },
    {
      quote: "If you can think, you can do math.",

      color: "#118AB2", // Blue
    },
    {
      quote: "mafs-ology - mehmehmehmeh.",

      color: "#073B4C", // Dark blue
    },
    {
      quote: "You don’t need to be fast—just curious.",

      color: "#EF476F", // Pink-red
    },
    {
      quote:
        "Pure mathematics is, in its way, the poetry of logical ideas. — Albert Einstein",

      color: "#7209B7", // Purple
    },
    {
      quote: "Geometry: Keeping you in shape since 300 BC.",

      color: "#3A86FF", // Bright blue
    },
    {
      quote: "67 is a prime number.",

      color: "#8338EC", // Violet
    },
  ];

  const { loading, setloading } = useLoading();
  const [LoginState, setLogin] = useState(false);
  const location = useLocation();
  const [randomQuote, setRandomQuote] = useState(quotes[0]);

  useEffect(() => {
    // Pick a random quote when route changes
    const randomIndex = Math.floor(Math.random() * quotes.length);
    setRandomQuote(quotes[randomIndex]);
  }, [location.pathname]); // Trigger on route change
  return (
    <div className="App">
      {<Navbar LoginState={LoginState} setLogin={setLogin} />}
      <div className="Quote" style={{ backgroundColor: randomQuote.color }}>
        <p>{randomQuote.quote}</p>
      </div>
      {loading ? (
        <LoadingPage />
      ) : (
        <div>
          <Routes>
            <Route path="/Report" element={<ReportForm />} />
            <Route
              path="/Dashboard"
              element={
                <ProtectedRoute
                  allowedRoles={["Admin", "Coordinator", "Moderator"]}
                >
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            {/* Home */}
            <Route path="/" element={<Home />} />
            {/* Login / Auth */}
            <Route
              path="/Login"
              element={
                <GuestRoute>
                  <LoginPage />
                </GuestRoute>
              }
            />
            {/* Challenges */}
            <Route
              path="/StudentsSubmissions"
              element={
                <ProtectedRoute
                  allowedRoles={["Admin", "Coordinator", "Moderator"]}
                >
                  <StudentsSubmission />
                </ProtectedRoute>
              }
            />
            {/* For !Student */}
            <Route
              path="/MySubmissions"
              element={
                <ProtectedRoute allowedRoles={["Student"]}>
                  <MySubmissions />
                </ProtectedRoute>
              }
            />
            {/* For Student */}
            <Route
              path="/WeeklyProblems"
              element={
                <OutOfServiceProtect allowedRoles={["Admin", "Dev"]}>
                  <WeeklyProblems />
                </OutOfServiceProtect>
              }
            />
            <Route path="/OpenProblems" element={<OpenProblems />} />
            <Route path="/OpenProblems/:unitId" element={<UnitLayout />} />
            <Route path="/ProblemOfTheDay" element={<DailyProblem />} />

            {/* ------------------------ Games ------------------------ */}
            <Route path="/Games" element={<Games />} />
            <Route path="/Games/CardGame" element={<OrderingCards />} />
            <Route path="/Games/Turbo" element={<Tubro />} />
            <Route path="/Games/Chess" element={<ChessBoards />} />
            <Route path="/Games/Confucius" element={<Confucius />} />
            {/* ------------------------ Games ------------------------ */}

            {/* Submission */}
            <Route
              path="/Submission/:referenceCode/:studentId"
              element={
                <ProtectedRoute
                  allowedRoles={["Admin", "Coordinator", "Moderator"]}
                >
                  <Submission4Correctors />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Submission/:referenceCode"
              element={
                <ProtectedRoute allowedRoles={["Student"]}>
                  <Submission4Student />
                </ProtectedRoute>
              }
            />

            {/* Archive */}
            <Route path="/Archive" element={<Archive />} />
            {/* Resources */}
            <Route path="/Resources" element={<Resources />} />
            {/* Annoucement */}
            <Route path="/Annoucement" element={<Annoucement />} />
            {/* Profile */}
            <Route path="/Profile" element={<Profile />} />
            <Route path="/unauthorized" element={<Error403Layout />} />
            <Route path="/OutOfService" element={<OutOfService />} />
            <Route path="/terms" element={<TermsAndConditions />} />
            <Route path="*" element={<Error404Layout />} />
          </Routes>
        </div>
      )}

      <div>
        <Footer />
      </div>
    </div>
  );
}

export default App;
